export default __webpack_public_path__ + "static/media/tick.6d45b966.svg";